import { z } from 'zod';

export const ContactoLeadInputSchema = z.object({
  nombre: z.string().trim().min(2).max(120),
  email: z.email().max(254),
  telefono: z.string().trim().max(30).optional(),
  rol: z.enum(['administrador', 'comite', 'propietario', 'residente', 'otro']),
  condominio: z.string().trim().max(200).optional(),
  unidades: z.enum(['<30', '30-80', '80-200', '>200']).optional(),
  comuna: z.string().trim().max(120).optional(),
  mensaje: z.string().trim().min(10).max(2000),
  website: z.string().max(500).optional(), // honeypot — checked in handler, not schema
});

export type ContactoLeadInput = z.infer<typeof ContactoLeadInputSchema>;
